import React from 'react';

import { connect } from 'react-redux';
import { reduxForm, Field, FieldArray } from 'redux-form';

import { namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import InputField from '../../../shared/form-elements/input';
import SelectField from '../../../shared/form-elements/select/field';
import { isRequired, isSelected } from '../../../shared/form/validation';

import TemplatesField from '../../components/templates-field';
import TestEmailForm from '../../components/test-email-modal';

import { enum as permissions } from '../../../../../../../enums/admin-permissions';

function MailingEditor({ intl, check, handleSubmit, ...props }) {
	const disabled = !check(permissions.mailingsCreate);
	return (
		<div className='form-container'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('create/edit triggered mailing')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form
					className='mailings-new-form'
					onSubmit={handleSubmit}
				>
					<div className='mailings-new-form-row'>
						<div className='mailings-new-form-field-from'>
							<Field
								name='from'
								placeholder={intl('From')}
								component={InputField}
								validate={[isRequired]}
								showLabel={false}
								disabled={disabled}
							/>
						</div>
						<div className='mailings-new-form-field-language'>
							<Field
								name='language'
								placeholder={intl('Language')}
								component={SelectField}
								searchable={false}
								multi={false}
								showLabel={false}
								clearable={false}
								options={props.options.languages}
								disabled={disabled}
							/>
						</div>
					</div>
					<div className='mailings-new-form-row'>
						<div className='mailings-new-form-field-event'>
							<Field
								name='event'
								placeholder={intl('Event')}
								component={SelectField}
								validate={[isSelected]}
								searchable={false}
								multi={false}
								showLabel={false}
								clearable={false}
								options={props.options.events}
								disabled={disabled}
							/>
						</div>
					</div>
					<FieldArray
						name='templates'
						component={TemplatesField}
						intl={intl}
						openTestEmailModal={props.openTestEmailModal}
						disabled={disabled}
					/>
					<TestEmailForm
						intl={intl}
						initialValues={props.testEmailFormInitialValues}
						showTestEmailModal={props.showTestEmailModal}
						toggleTestEmailModal={props.toggleTestEmailModal}
						sendTestEmail={props.sendTestEmail}
						adminsLookup={props.adminsLookup}
					/>
					<div className='mailings-new-form-planner'>
						<button
							className='ui-btn ui-btn-primary'
							disabled={disabled}
						>
							Save
						</button>
					</div>
				</form>
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		// -----------------------------------------
		options: selectors.getOptions(state),
		testEmailFormInitialValues: selectors.getTestEmailFormInitialValues(state),
		showTestEmailModal: selectors.select(state, 'showTestEmailModal')
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(MailingEditor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/triggered-mailings/editor/main.js